export default __webpack_public_path__ + "static/media/carousel4.3878f181.png";